import React, { Component } from 'react';
import Countdown from 'react-countdown';
import TestQues from './TestQues'
import Grid from '@material-ui/core/Grid';
import fire from '../../config/fire'

class TestQuiz extends Component {

    constructor(props) {
        super(props)

        this.state = {
            fill: true,
            attempt: 1
        }
    }

    handleText = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });
    };

    handleAttempt = () => {
        this.setState({
            attempt: 0
        });
    };

    componentDidMount() {
        const token = window.localStorage.getItem('token')
        fetch(`https://recruitingmonk-v2.azurewebsites.net/quiz/boolean/${this.props.uid}`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token,
                }
              })
                .then(
                  (response) => {
                    if (response.ok) {
                      console.log(response);
                      return response;
                    } else {
                      var error = new Error(
                        "Error " + response.status + ": " + response.statusText
                      );
                      error.response = response;
                      throw error;
                    }
                  },
                  (error) => {
                    var errmess = new Error(error.message);
                    throw errmess;
                  }
                )
                .then((response) => response.json())
                .then((response) => {
                  if (!response.success)
                        this.setState({fill:false})
                })
                .catch((error) => {
                    this.setState({fill:false})
                });
    }

    renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            this.handleAttempt()
            return <h2>Time's Up!!</h2>
        } else {
            // Render a countdown
            return (
                <Grid item xs={12} className="clock">
                    <h1>{minutes}:{seconds}</h1>
                </Grid>
            )
        }
    };

    render() {

        return (
            <div>
                {
                    this.state.fill ?
                        <Grid container className="quiz">
                            <Grid item xs={12} md={10} align="left">
                                <p style={{ fontSize: '18px', paddingLeft: '10px' }}>Recruiter Quiz <span style={{ fontWeight: '500' }}>Powered by</span> RecruitingMonk</p>
                                <p style={{ fontSize: '15px', paddingLeft: '10px' }}>Recruiter Hiring - JP Morgan</p>
                            </Grid>
                            <Grid item xs={12} md={2} align="right">
                                <Countdown
                                    date={Date.now() + 600000}
                                    renderer={this.renderer}
                                /></Grid>
                            <Grid container>
                                <Grid item xs={12} md={7} className="questions">
                                    <TestQues uid={this.props.uid} fill={this.state.fill} attempt={this.state.attempt} name={this.props.name} email={this.props.email} />
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={12} style={{ padding: '10px' }}>
                                <p>Quiz Already Attempted</p>
                            </Grid>
                        </Grid>
                }
            </div>
        );
    }
}

export default TestQuiz;